module.exports = __webpack_public_path__ + "static/img/14000135.d831fe41.png";